<template>
  <div class="folder-header">
    <div class="folder-header-search">
      <b-form onsubmit="return false">
        <b-input-group size="sm">
          <b-form-input
            @keyup.enter="query"
            type="search"
            v-model.trim="form.keyword"
            :placeholder="
              $l('table_search_folder') || '文件名/文档说明/目录 搜索……'
            "
          />
          <b-input-group-append>
            <b-button-group>
              <b-button-group slot="reference">
                <b-button
                  variant="link"
                  size="sm"
                  class="search-dropdown-button"
                  squared
                  @click="openAdvqueryDialog"
                >
                  {{ $l('INDEX.advanced_search') || '高级搜索' }}
                </b-button>
                <b-button variant="primary" size="sm" @click="query">
                  <i class="fa fa-search" />
                </b-button>
              </b-button-group>
            </b-button-group>
          </b-input-group-append>
        </b-input-group>
      </b-form>
    </div>
    <div class="folder-header-button">
      <b-button
        variant="outline-primary"
        size="sm"
        @click="$emit('create-folder')"
      >
        <i class="el-icon-folder-add" />
        {{ $l('btn_createFolder') || '新建文件夹' }}
      </b-button>
      <b-button
        variant="primary"
        size="sm"
        class="ml-2"
        @click="$emit('upload-doc')"
      >
        <i class="el-icon-upload" />
        {{ $l('btn_uploadDoc') || '上传文件' }}
      </b-button>
    </div>

    <el-drawer
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :visible.sync="advqueryDialogVisible"
      :size="600"
      append-to-body
      :show-close="false"
      :wrapper-closable="false"
      :close-on-press-escape="false"
      @close="closeAdvqueryDialog()"
    >
      <template #title>
        <span role="heading">
          {{ $l('INDEX.advanced_search') || '高级搜索' }}
        </span>
        <el-button size="small" @click="closeAdvqueryDialog">
          {{ $l('INDEX.btn_cancel_query') || '取消查询' }}
        </el-button>
        <el-button size="small" type="warning" @click="reset">
          {{ $l('INDEX.btn_reset_filter') || '重置条件' }}
        </el-button>
        <el-button size="small" type="primary" @click="advquery">
          {{ $l('INDEX.btn_data_retrieval') || '数据检索' }}
        </el-button>
      </template>
      <div class="drawer-main">
        <el-form ref="form" :model="form" size="small" label-position="top">
          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_folderSearch_name') || '名称'"
              >
                <el-input
                  v-model="form.custFileName"
                  :placeholder="
                    $l('form_placeholder_folderSearch_name') || '请输入名称'
                  "
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_folderSearch_docType') || '文档类型'"
              >
                <dict-select
                  v-model="form.custFileDescCodes"
                  url="/master/common/dict/biz"
                  :body="{ dictType: 'custFileDescType' }"
                  :placeholder="
                    $l('form_placeholder_folderSearch_docType') ||
                      '请选择文件类型'
                  "
                  filterable
                  clearable
                  multiple
                  style="width: 100%"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                :label="
                  $l('form_label_folderSearch_relatedNotes') || '文档相关说明'
                "
              >
                <el-input
                  v-model="form.custFolderDesc"
                  :placeholder="
                    $l('form_placeholder_folderSearch_relatedNotes') ||
                      '请输入文档相关说明'
                  "
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-row>
                <el-form-item
                  :label="
                    $l('form_label_folderSearch_modifyDate') || '更新日期'
                  "
                >
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.modifyDateStart"
                      :placeholder="
                        $l('form_placeholder_folderSearch_modifyDate') ||
                          '请选择更新日期'
                      "
                      value-format="yyyy-MM-dd"
                      type="date"
                      style="width: 100%"
                    />
                  </el-col>
                  <el-col class="text-center" :span="2">-</el-col>
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.modifyDateEnd"
                      :placeholder="
                        $l('form_placeholder_folderSearch_modifyDate') ||
                          '请选择更新日期'
                      "
                      value-format="yyyy-MM-dd"
                      type="date"
                      style="width: 100%"
                    />
                  </el-col>
                </el-form-item>
              </el-row>
            </el-col>
            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_folderSearch_status') || '状态'"
              >
                <el-checkbox-group v-model="form.listCustFileStatus">
                  <el-checkbox label="Y">
                    {{ $l('form_label_folderSearch_status_Y') || '有效' }}
                  </el-checkbox>
                  <el-checkbox label="N">
                    {{ $l('form_label_folderSearch_status_N') || '已停用' }}
                  </el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="drawer-footer">
        <el-button size="small" @click="closeAdvqueryDialog">
          {{ $l('INDEX.btn_cancel_query') || '取消查询' }}
        </el-button>
        <el-button size="small" type="warning" @click="reset">
          {{ $l('INDEX.btn_reset_filter') || '重置条件' }}
        </el-button>
        <el-button size="small" type="primary" @click="advquery">
          {{ $l('INDEX.btn_data_retrieval') || '数据检索' }}
        </el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
const initForm = { keyword: '', custFileDescCodes: [], listCustFileStatus: [] }
export default {
  data() {
    return { advqueryDialogVisible: false, form: { ...initForm } }
  },
  methods: {
    query({ isReset = false } = {}) {
      if (isReset) this.reset()
      this.$emit('query', this.form)
    },
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    reset() {
      this.form = { ...initForm }
    },
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.folder-header {
  display: flex;
  justify-content: space-between;
  padding: 2px 0;
  .folder-header-search {
    width: 100%;
    max-width: 550px;
    .input-group input {
      border-right: none;
    }
  }
  .folder-header-button {
    min-width: max-content;
  }
}

.drawer-main {
  padding: 0 20px 20px;
}
.drawer-footer {
  padding: 10px 20px 30px;
  display: flex;
  justify-content: flex-end;
}
</style>
